import formatMessage from 'format-message'
import React from 'react'
import DownloadIcon from './icons/DownloadIcon'

export default function GenerateMergedPdf({ generateMergedPdf, color, text }) {
  const clickHandler = (event) => {
    event.preventDefault()
    generateMergedPdf()
  }

  const defaultText = formatMessage('Download with Annotations & Comments')
  const defaultColor = '#ffffff'

  return (
    <div>
      <button
        className="download-button--button"
        onClick={clickHandler}
        title={text || defaultText}
        aria-label={text || defaultText}
      >
        <DownloadIcon color={color || defaultColor} />
      </button>
    </div>
  )
}
